/**
 * Generate a secure password for new users
 * Requirements: min 8 chars, include a number, include uppercase/lowercase
 */
export const generateSecurePassword = () => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz'
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numbers = '0123456789'
  const symbols = '!@#$%&*'

  // Ensure we have at least one of each required type
  let password = ''
  password += lowercase[Math.floor(Math.random() * lowercase.length)]
  password += uppercase[Math.floor(Math.random() * uppercase.length)]
  password += numbers[Math.floor(Math.random() * numbers.length)]
  password += symbols[Math.floor(Math.random() * symbols.length)]

  // Fill the rest randomly from all characters
  const allChars = lowercase + uppercase + numbers + symbols
  for (let i = password.length; i < 12; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)]
  }

  // Shuffle the password
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('')
}

/**
 * Validate that a password meets OMS requirements
 */
export const validatePassword = password => {
  if (!password) return { valid: false, error: 'Please enter a password' }
  if (password.length < 8)
    return { valid: false, error: 'Password must be at least 8 characters' }
  if (!/\d/.test(password))
    return { valid: false, error: 'Password must include at least one number' }
  if (!/[A-Z]/.test(password))
    return {
      valid: false,
      error: 'Password must include at least one uppercase letter',
    }
  if (!/[a-z]/.test(password))
    return {
      valid: false,
      error: 'Password must include at least one lowercase letter',
    }

  return { valid: true }
}
